<template lang="pug">
    v-container.auth-container
        v-card.auth.elevation-20(width="600")
            v-container
                v-form(@submit="loginUser($event)")
                    v-card-title
                        span.title Alter API Auth
                    v-card-text
                        v-text-field(
                            v-model="login"
                            outlined
                            placeholder="Введите логин"
                            label="Логин в системе AlterTaxi"
                            :error-messages="getValidateMessage('Auth', 'login')"
                        )
                        v-text-field(
                            v-model="password"
                            type="password"
                            outlined
                            placeholder="Введите пароль"
                            label="Пароль"
                            :error-messages="getValidateMessage('Auth', 'password')"
                        )
                        v-select(
                            v-model="server"
                            outlined
                            label="Сервер AlterTaxi"
                            placeholder="Выберите сервер"
                            :items="cities"
                            :error-messages="getValidateMessage('Auth', 'server')"
                        )
                    v-card-actions.px-4
                        v-btn(type="submit" width="100%" :dark="!loading" :disabled="loading") Войти

</template>

<style scoped lang="scss">
    .auth {

        &-container {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 100%;
        }
    }
</style>

<script>
import { validationMixin } from 'vuelidate';
import { required, minLength } from 'vuelidate/lib/validators';
import validate from '@/mixins/validate';
import request from '@/utils/request';

export default {
    mixins: [validationMixin, validate],
    name: 'Login',
    validations: {
        login: {
            required
        },
        password: {
            required,
            minLength: minLength(6)
        },
        server: {
            required
        }
    },
    data: () => ({
        loading: false,
        login: '',
        password: '',
        server: 'vin'
    }),
    computed: {
        cities() {
            return [{
                text: "Винница",
                value: "vin"
            }, {
                text: "Умань",
                value: "umn"
            }]
        }
    },
    methods: {
        async loginUser(event) {
            event.preventDefault();

            if (this.$v.$invalid) {
                return this.$v.$touch()
            }

            if (this.loading) return;

            this.loading = true;

            await request({
                method: 'post', url: '/api/login', data: {
                    login: this.login,
                    password: this.password,
                    server: this.server
                },
                withCredentials: true
            }).then(res => {
                if (res.status == 200 && res.data.token) {
                    localStorage.setItem('user-token', res.data.token);
                    this.$store.commit('AUTH_SUCCESS', res.data);

                    this.$notify({
                        group: 'app',
                        title: 'Sucess Auth',
                        text: `Вы успешно авторизированы`,
                        type: 'success'
                    });

                    this.$router.push('/');
                } else {
                    this.$store.commit('AUTH_ERROR');
                    localStorage.removeItem('user-token');

                    this.$notify({
                        group: 'app',
                        title: 'Auth Error',
                        type: 'error',
                        text: `Неизвестная ошибка: response status [${res.status}]`
                    });
                }
            }).catch(err => {
                this.$store.commit('AUTH_ERROR');
                localStorage.removeItem('user-token');
                
                if (err.response && err.response.data && typeof err.response.data == 'string') {
                    this.$notify({
                        group: 'app',
                        title: 'Auth Error',
                        type: 'error',
                        text: err.response.data
                    });
                } else {
                    this.$notify({
                        group: 'app',
                        title: 'Auth Error',
                        type: 'error',
                        text: `Неизвестная ошибка`
                    });
                }
            });

            setTimeout(() => {
                this.loading = false
            }, 1500)
        }
    }
}
</script>
